<template>
  <div class="vp-card-list" :style="wrapStyle">
    <n-label-card v-for="(item, i) in list" :key="`${i}-${item.sn}`" :style="cardStyle">
      <div class="column">
        <span class="name" :style="{ fontSize: font.main }">
          {{ item.name }}
        </span>
        <span class="detail" :style="{ fontSize: font.second }">
          <span>检测编号</span>
          <span>{{ item.sn }}</span>
        </span>
      </div>
      <div class="column">
        <div class="detail"></div>
        <div class="detail" :style="{ fontSize: font.second }">
          {{ item.date }}
        </div>
      </div>
    </n-label-card>
  </div>
</template>

<script>
import NLabelCard from '@/components/virtualPhone/components/LabelCard';

export default {
  components: {
    NLabelCard
  },
  inject: ['calc'],
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    font() {
      const { calc } = this;
      return {
        main: calc(30),
        second: calc(24)
      };
    },
    cardStyle() {
      return {
        marginBottom: this.calc(30)
      };
    },
    wrapStyle() {
      return {
        marginTop: this.calc(30)
      };
    }
  }
};
</script>

<style lang="scss">
.vp-card-list {
  display: flex;
  flex-direction: column;

  .vp-card-wrap {
    display: flex;
    justify-content: space-between;
  }
  .column {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .name {
      margin-bottom: 2px;
    }
    .detail {
      color: #d0d0d0;
    }
  }
}
</style>
